import smoothScroll from './smooth-scroll';
export var onPaginationClick = function (headerBarRef, direction) {
    if (!(headerBarRef === null || headerBarRef === void 0 ? void 0 : headerBarRef.current)) {
        return;
    }
    var element = headerBarRef.current;
    var paginatedSectionSize = element.clientWidth * 0.75;
    if (direction === 1) {
        smoothScroll(element, Math.min(element.scrollLeft + paginatedSectionSize, element.scrollWidth - element.offsetWidth));
    }
    if (direction === -1) {
        smoothScroll(element, Math.max(element.scrollLeft - paginatedSectionSize, 0));
    }
};
export var hasHorizontalOverflow = function (headerBar, leftOverflowButton) {
    var offsetWidth = headerBar.offsetWidth, scrollWidth = headerBar.scrollWidth;
    var paginationButtonsWidth = leftOverflowButton.current && 2 * leftOverflowButton.current.offsetWidth;
    return paginationButtonsWidth ? scrollWidth > offsetWidth + paginationButtonsWidth : scrollWidth > offsetWidth;
};
export var hasLeftOverflow = function (headerBar) {
    return headerBar.scrollLeft > 0;
};
export var hasRightOverflow = function (headerBar) {
    var offsetWidth = headerBar.offsetWidth, scrollLeft = headerBar.scrollLeft, scrollWidth = headerBar.scrollWidth;
    return scrollLeft < scrollWidth - offsetWidth;
};
export var scrollIntoView = function (tabHeader, headerBar, smooth) {
    if (smooth === void 0) { smooth = true; }
    if (!tabHeader || !headerBar) {
        return;
    }
    var margin = 1;
    var updatedLeftScroll = headerBar.scrollLeft;
    updatedLeftScroll = Math.min(updatedLeftScroll, tabHeader.offsetLeft - margin);
    updatedLeftScroll = Math.max(updatedLeftScroll, tabHeader.offsetLeft + tabHeader.offsetWidth - headerBar.offsetWidth + margin);
    if (smooth) {
        smoothScroll(headerBar, updatedLeftScroll);
    }
    else {
        headerBar.scrollLeft = updatedLeftScroll;
    }
};
